import type { EntityState } from '@reduxjs/toolkit';

import type { IHistoryGame } from '../../../api/fetchers/history/types';
import { useCoreSelector } from '../../CoreStore';

import type { HistoryState } from './types';

export const useHistorySlice = {
  getHistory: (): EntityState<IHistoryGame> & HistoryState => {
    return useCoreSelector(({ history }) => history);
  },
  getGameInfo: (): IHistoryGame | null => {
    return useCoreSelector(({ history }) => history.gameInfo);
  },
  getLoadingDetails: (): boolean => {
    return useCoreSelector(({ history }) => history.loadingDetails);
  },
};
